// @flow
import 'whatwg-fetch';
import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { CookiesProvider } from 'react-cookie';
import { Helmet } from 'react-helmet';
import ReactModal from 'react-modal';
import './index.css';
import reduxStore from './store';
import App from './containers/AppContainer';
import PermissionAPI from './services/PermissionAPI';
import { themes } from './themes';

const themeName = process.env.REACT_APP_THEME || 'base';
const brand =
  process.env.REACT_APP_BRAND || process.env.REACT_APP_THEME || null;
const clientVersion = process.env.REACT_APP_GITHASH;
// this will be evaluated to string
const underMaintenance = process.env.REACT_APP_UNDER_MAINTENANCE

let analyticsEnv = 'dev';

if (
  window.location.hostname.includes('mypreferences.thesun') ||
  window.location.hostname.includes('mypreferences.thetimes') ||
  window.location.hostname.includes('mypreferences.wireless') ||
  window.location.hostname.includes('mypreferences.the-tls')
) {
  analyticsEnv = 'prod';
}

const api = new PermissionAPI(brand, { clientVersion });
const store = reduxStore({ api, brand });
const container: Element | null = document.getElementById('root');

if (!brand) {
  throw new Error('REACT_APP_BRAND must be set');
}

if (container == null) {
  throw new Error('no react root element');
}

ReactModal.setAppElement(container);
const root = createRoot(container);
root.render(
  <>
    <Helmet>
      <link rel="icon" href={themes[themeName].assets.favicon} />
      {themes[themeName].show.analytics &&
        <script
          async
          src={`//tags.tiqcdn.com/utag/newsinternational/${themes[themeName].strings.analytics.tag}/${analyticsEnv}/utag.js`}
        />
      }
    </Helmet>
    <Provider store={store}>
      <CookiesProvider>
        <App
          theme={themes[themeName]}
          brand={brand}
          version={clientVersion}
          analyticsEnv={analyticsEnv}
          underMaintenance={underMaintenance}
        />
      </CookiesProvider>
    </Provider>
  </>
);
